import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const bodyScrollOptions = {
  reserveScrollBarGap: true
};

const hamburgerMenu = document.querySelector('.header__hamburger');
const mobileMenu = document.querySelector('.mobile-menu');
const mobileMenuScroll = document.querySelector('.mobile-menu__scroll');

if (hamburgerMenu && mobileMenu && mobileMenuScroll) {
  let timeout = false;
  let isActive = false;
  hamburgerMenu.addEventListener('click', () => {
    hamburgerMenu.classList.toggle('is-active');

    isActive = !isActive;
    clearTimeout(timeout);

    if (isActive) {
      disableBodyScroll(mobileMenuScroll, bodyScrollOptions);

      mobileMenu.style.display = 'block';
      timeout = setTimeout(() => {
        mobileMenu.classList.add('is-active');
      }, 100);
    } else {
      enableBodyScroll(mobileMenuScroll, bodyScrollOptions);

      mobileMenu.classList.remove('is-active');
      timeout = setTimeout(() => {
        mobileMenu.style.display = 'none';
      }, 550);
    }
  });
}
